import { render, staticRenderFns } from "./ParentPaymentHistory.vue?vue&type=template&id=26e83585&"
import script from "./ParentPaymentHistory.vue?vue&type=script&lang=js&"
export * from "./ParentPaymentHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports